<template>
  <div class="choice-radio-group">
    <ChoiceRadio
      v-for="(choice, index) in choices"
      :key="index"
      :value="choice.value"
      :checked="value === choice.value"
      :border-top="index === 0"
      border-bottom
      border-left
      border-right
      @input="input">{{ choice.text }}</ChoiceRadio>
  </div>
</template>

<script>
import ChoiceRadio from '@/components/Forms/ChoiceRadio';

export default {
  name: 'ChoiceRadioGroup',
  components: {
    ChoiceRadio,
  },
  props: {
    choices: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    input(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
